import React, { useEffect, useRef, useState } from "react";


const Scroll = ({ children, height, noMore, setCurrentData, className }) => {

    const [isFetching, setIsFetching] = useState();
    const ref = useRef();

    useEffect(() => {
        if (ref && ref.current) {
            ref.current.scrollTop = 0
        }
    }, [])

    const handleScroll = (event) => {
        if (event.target.scrollHeight - (event.target.offsetHeight + event.target.scrollTop) < (height || 500) && !isFetching && !noMore) {
            setIsFetching(true);
        }
    };

    useEffect(() => {
        (async () => {
            if (isFetching) {
                await setCurrentData()
                setIsFetching(false);
            }
        })()
    }, [isFetching])

    return (
        <div className={className} onScroll={handleScroll} ref={ref}>
            {children}
        </div>
    )
}
export default Scroll;